import { Button } from '@mui/material';
import { SxProps } from '@mui/system';

type TextButtonProps = {
  text: string;
  onClick: () => void;
  sx?: SxProps;
  disabled?: boolean;
};

function TextButton(props: TextButtonProps) {
  const { sx, text, onClick, disabled } = props;
  return (
    <Button
      sx={{ textDecoration: 'none', fontSize: '14px', fontWeight: 'bold', ...sx }}
      variant="tertiary"
      onClick={onClick}
      disabled={disabled}
    >
      {text}
    </Button>
  );
}

export default TextButton;
